module.exports = __webpack_public_path__ + "static/media/mindfulness.34851511.jpg";